<template>
    <div class='rolecard' @click="click">
        <p v-if="role.user" class="image is-96x96 is-inline-block">
          <img class='is-rounded' :src="role.user.image[0].sizes.circularList" />
        </p>
        <div v-if="!role.user" class='placeholder'></div>
        <div class="content">
          <h3 v-if="role.user" class='title is-5'>{{role.user.firstName}} {{role.user.lastName}}</h3>
          <h3 v-if="!role.user" class='title is-5'>&nbsp;<small>&lt;Empty&gt;</small></h3>
          <h4 class='subtitle is-6'>
              {{role.name}}<br/>
              <b-tooltip label="One or more students have applied to this position" position="is-top" type="is-dark">
                <b-tag v-if="role.applications && role.applications.length > 0" type="is-success">{{role.applications.length}}</b-tag>
              </b-tooltip>
              <b-tooltip label="You have a pending application for this position" position="is-top" type="is-dark">
                  <b-tag v-if="isApplied" type="is-info">
                    <b-icon
                        icon="file-document"
                        size="is-small">
                    </b-icon>
                  </b-tag>
              </b-tooltip>
          </h4>
        </div>
    </div>
</template>

<style scoped>
.rolecard {
    min-width: 20%;
    height: 185px; /* fix height so cards without b-tags underneath are same height as those that have tags */
    float: left;
    margin: 1.1em 0;
    text-align: center;
    cursor: pointer;
}
.rolecard:hover {
    box-shadow: 0px 0px 6px #ddd;
}
h3, h4 { font-weight: normal; }
.subtitle { font-style: italic; }
.placeholder {
    width: 96px;
    height: 96px;
    border: 4px SOLID #DDD;
    border-radius: 100%;
    display: inline-block;
    margin: auto;
}
</style>

<script>
export default {
  name: 'RoleCard',
  props: ['role', 'showIfApplied'],
  methods: {
    click() {
      this.$emit('click', this.$props.role);
    }
  },
  computed: {
    isApplied() {
      if(this.$props.showIfApplied && this.$root.applications) {
        var that = this;
        var foundApplication = this.$root.applications.find(function(application) {
          return application.role === that.$props.role.id;
        });

        return !!foundApplication;
      }
      return false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RoleCard.vue